import React, { SyntheticEvent, useState } from "react";
import { Autocomplete, AutocompleteCloseReason, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ColumnModel, ColumnModelItem } from "components/tables/columns/ColumnModel";

interface StaticTableDialogContentProps {
  columnModelState: ColumnModel;
  onColumnsToAdd: (columnsToAdd: ColumnModelItem[]) => void;
}

export default function StaticTableDialogContent(props: StaticTableDialogContentProps) {
  const { i18n } = useTranslation();
  const [columnsToAdd, setColumnsToAdd] = useState<ColumnModelItem[] | []>([]);

  const hiddenColumns = props.columnModelState.columns.filter((colItem: ColumnModelItem) => {
    return colItem.hidden === true;
  });

  return (
    <Autocomplete
      sx={{ pt: 1 }}
      disableCloseOnSelect
      freeSolo
      multiple
      getOptionLabel={(option: string | ColumnModelItem) => {
        return typeof option === "string" ? option : option.headerName ?? option.field;
      }}
      renderInput={(params) =>
        <TextField
          autoComplete="off"  
          label={i18n.t("tables.select-one-more-columns")}
          {...params}
        />
      }
      options={hiddenColumns ?? []}
      onChange={(event, newColumns: (string | ColumnModelItem)[]) => {
        const isColumnsArray = newColumns.every((item) => {
          return typeof item !== "string";
        });
        if (newColumns && isColumnsArray) {
          setColumnsToAdd(newColumns);
        }
      }}
      onClose={(event: SyntheticEvent<Element, Event>, reason: AutocompleteCloseReason) => {
        props.onColumnsToAdd(columnsToAdd);
      }}
    />
  );
}